$(function() {
  $('.brickulator__submit--std').click(function() {
    wallLength = $('#std-wall-length').val();
    wallHeight = $('#std-wall-height').val();
    brickHeight = $('input[name="std-brick-height"]:checked').val() / 1000;
    
    if ( $('#pre-war-brick-height').is(':checked') ) {
      brickLength = $('#std-brick-length').val() / 1000;
    } else {
      brickLength = $('#pre-war-brick-length').val() / 1000;
    }

    mortarThickness = 0.01;

    if ( wallLength == 0 || wallHeight == 0 ) {
      setStdCalcMessage('Please use values higher than 0 for your wall measurements!');
    } else {
      bricksNeeded = calculateBricks(wallLength, wallHeight, brickLength, brickHeight, mortarThickness);
      wallArea = wallLength * wallHeight;
      setStdCalcMessage('<p>Wall Area: </p><p><span>' + wallArea + '</span>m<sup>2</sup></p>' + '<p>Bricks required: </p><p><span>' + bricksNeeded + '</span></p>');
    }
  });

  $('.brickulator__submit--cst').click(function() {
    wallLength = $('#cst-wall-length').val();
    wallHeight = $('#cst-wall-height').val();
    brickLength = $('#cst-brick-length').val() / 1000;
    brickHeight = $('#cst-brick-height').val() / 1000;
    mortarThickness = $('#cst-mortar-size').val() / 1000;

    if ( wallLength == 0 || wallHeight == 0 || brickLength == 0 || brickHeight == 0 || mortarThickness == 0 ) {
      setCstCalcMessage('Please use values higher than 0 for your wall measurements!');
    } else {
      bricksNeeded = calculateBricks(wallLength, wallHeight, brickLength, brickHeight, mortarThickness);
      wallArea = wallLength * wallHeight;
      setCstCalcMessage('<p>Wall Area: </p><p><span>' + wallArea + '</span>m<sup>2</sup></p>' + '<p>Bricks required: </p><p><span>' + bricksNeeded + '</span></p>');
    }
  });
});

/*
  bricks needed = (L * H) / ((l + t) * (h + t))

  L - Length of the wall;
  H - Height of the wall;
  l - Length of a brick;
  t - Thickness of mortar joint; and
  h - Height of a brick.
*/
function calculateBricks( wallLength, wallHeight, brickLength, brickHeight, mortarThickness ) {
  return addCommas(Math.ceil((wallLength * wallHeight) / ((brickLength + mortarThickness) * (brickHeight + mortarThickness))));
}

function setStdCalcMessage( message ) {
  $('.brickulator__result-holder--std').empty();
  $('.brickulator__result-holder--std').append(message);
}

function setCstCalcMessage( message ) {
  $('.brickulator__result-holder--cst').empty();
  $('.brickulator__result-holder--cst').append(message);
}

function addCommas(nStr) {
  nStr += '';
  var x = nStr.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}